<div class="exceptions-container">
  <h3>Excepciones</h3>
  <p>Configuración de excepciones de horario (días especiales, festivos, etc.).</p>
  <p>Location ID: {{ locationId }}</p>
</div>
